<template>
  <footer
    id="footer"
    class="relative p-2 bg-white text-xs flex flex-col items-center h-12 mt-auto w-full"
  >
    <div class="flex items-center justify-center gap-4 h-full">
      <img
        :src="CogtaLogo"
        alt="COGTA logo"
        class="block h-full w-auto"
      >

      <img
        :src="NationalStrategicHubLogo"
        alt="National Strategic Hub logo"
        class="block h-full w-auto"
      >

      <img
        :src="DDMLogo"
        alt="District Development Model logo"
        class="block h-full w-auto"
      >

      <img
        :src="SMDigital"
        alt="SM Digital logo"
        class="block h-full w-auto"
      >
    </div>

    <span class="mt-0.5 text-[9px] absolute right-2 bottom-1">
      {{ appName }} v{{ appVersion }}
    </span>
  </footer>
</template>

<script setup>

import DDMLogo from '@/assets/images/logos/ddm-transparent-logo.png';
import CogtaLogo from '@/assets/images/logos/logo-cogta.png';
import NationalStrategicHubLogo from '@/assets/images/logos/national-strategic-hub-logo.webp';
import SMDigital from '@/assets/images/logos/sm-digital-logo.svg';

const {
  VITE_APP_NAME: appName,
  VITE_APP_VERSION: appVersion,
} = import.meta.env;
</script>
